import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.espaco.md};
  min-height: 100dvh;
  padding: ${({ theme }) => theme.espaco.xl} ${({ theme }) => theme.espaco.lg};
  background-color: ${({ theme }) => theme.cores.card};
  text-align: center;

  h1 {
    font-size: 48px;
    color: ${({ theme }) => theme.cores.primary};
  }

  h2 {
    font-size: ${({ theme }) => theme.fonte.h2};
    color: ${({ theme }) => theme.cores.ink};
  }

  span {
    max-width: 480px;
    color: ${({ theme }) => theme.cores.inkSecondary};
  }

  a {
    text-decoration: none;
  }

  ${media.mobile} {
    h1 {
      font-size: 36px;
    }
  }
`;

export const GifDiv = styled.div`
  width: 100%;
  max-width: 400px;
  height: 300px;
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  ${media.mobile} {
    height: 220px;
  }
`;
